import { composeIO } from 'react-compose-io'
import { itemAssociacaoIO } from './ItemAssociacao.IO'
import ItemAssociacaoView from './ItemAssociacao.View'

export const ItemAssociacao = composeIO(ItemAssociacaoView, itemAssociacaoIO)
